import { Component } from '@angular/core';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { filter } from 'rxjs';
import { CommonModule } from '@angular/common';
import { ContextUserService } from '../../../services';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule, RouterLink],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent {
  currentUrl: any = '';
  sidebarWidth: number = 60;
  sidebarComprimido: boolean = true;
  activeHome: boolean = true;
  activeProcessList: boolean = false;
  activeAuditoriaList: boolean = false;
  isGuest!: boolean;
  user: any | null = null;

  constructor(
    private readonly _router: Router,
    private readonly _userContext: ContextUserService,
  ) {}

  async ngOnInit() {
    // await this._contextUser.setContextUser();
    const user = this._userContext.getUser || null;
    this.user = user;
    this.isGuest = user?.user?.usGuest ?? false;
    this.definirSeleccionActualSidebar();
  }

  ngAfterViewInit() {
    this._router.events
      .pipe(filter((event: any) => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.currentUrl = event.url;
        console.log('URL actual:', this.currentUrl);
        this.definirSeleccionActualSidebar();
      });
  }

  expandSidebar() {
    this.sidebarWidth = 285;
    this.sidebarComprimido = false;
  }

  collapseSidebar() {
    this.sidebarWidth = 60;
    setTimeout(() => {
      this.sidebarComprimido = true;
    }, 300);
  }

  definirSeleccionActualSidebar() {
    if (this.isGuest) return;
    const currentRoute = this._router.url;
    console.log('Ruta actual:', currentRoute);

    if (currentRoute === '/home') {
      console.log('home');
      this.selectOptionSidebar('home');
    } else if (currentRoute === '/process-list') {
      console.log('process-list');
      this.selectOptionSidebar('process-list');
    }else if (currentRoute === '/auditoria-list') {
      console.log('auditoria-list');
      this.selectOptionSidebar('auditoria-list');
    } else {
      console.warn('Ruta no reconocida:', currentRoute);
    }
  }

  selectOptionSidebar(option: any) {
    if (this.isGuest) return;

    const optionMap: Record<string, { property: string; route?: string }> = {
      home: { property: 'activeHome', route: 'home' },
      'process-list': { property: 'activeProcessList', route: 'process-list' },
      'auditoria-list': { property: 'activeAuditoriaList', route: 'auditoria-list' },
    };

    const selectedOption = optionMap[option];

    if (!selectedOption) {
      console.warn('Opción no reconocida:', option);
      return;
    }

    Object.values(optionMap).forEach((opt) => {
      (this as any)[opt.property] = false;
    });

    (this as any)[selectedOption.property] = true;

    if (selectedOption.route) {
      this._router.navigate([selectedOption.route]);
    }
  }
}
